const EditScaleRoute = [
  {
    path: '/edit-scale',
    name: 'EditScale',
    component: () => import('../../views/EditScale/Index.vue'),
  },
];

export default EditScaleRoute;
